import { API_URLS } from "@constants";
import * as G from "@globals";
import * as Q from "../queries";

export const gql = async ( queryName: keyof typeof Q, ...args: (string | number)[] ) => {

	try {

		const { address } = G.wallet.getBracketWallet();

		if(!address) {
			console.warn("Platform::gql requires a connected wallet.");
			return [];
		}

		const { GRAPHQL_API } = API_URLS;
		//@ts-expect-error -- sure...
		const query = Q[queryName](...args);
		let response: Response;
		try {

			response = await fetch(GRAPHQL_API, {
				method: "POST",
				body: JSON.stringify({
					query,
				}),	
				headers: {
					"Content-Type": "application/json",
					wallet: address,
				},
			});

		}
		catch(err) {
			console.warn("ACTUAL FETCH CALL AFILED");
			console.log("API", GRAPHQL_API);
			console.log("address", address);
			console.log("query", query);
			console.warn(`Platform::gql has failed - ${err instanceof Error ? err.message : "unknown error"}`);
			return [];
		}

		if(response.ok) {

			const {
				data,
				errors,
			} = await response.json();

			if(errors) {
				throw new Error(errors[0].message);
			}

			return data;
		}

		throw new Error("graphql query has failed.");
	}
	catch(err) {

		throw new Error(`Platform::gql has failed - ${err instanceof Error ? err.message : "unknown error"}`);
	}
}
